(function(window){
  if(window){
    window.__isDebugMode__ = (window.location.href.includes("debug"));
  }
})(window);

const INITIAL_STATE = {
  versao: '1.0.5',
  formulario: {},
  totalPerguntas:0,
  perguntasRespondidas: [],
  formularioResposta: {},
  sessoesFormulario: [],
  restricoesPreValidacao:[],
  verificacaoRespostaHabilitado:false,
  formularioAssistido:false,
  isDebug: window.__isDebugMode__
}

export {INITIAL_STATE}

export default {
  participante: {},
  clienteFormulario:{},
  ...INITIAL_STATE
}




// WEBPACK FOOTER //
// ./src/store/state.js